import type { Stage } from "../../../../../api/spark";
import Button from "../../../../../design-system/primitives/components/Button/Button";

interface StageChipProps {
  stage: Stage;
  isActive: boolean;
  disabled: boolean;
  onClick: () => void;
}

export const StageChip = ({
  stage,
  isActive,
  disabled,
  onClick,
}: StageChipProps) => (
  <Button
    title={stage.name}
    size="small"
    color={isActive ? "accent" : "neutral"}
    variant={isActive ? "primary" : "secondary"}
    disabled={disabled}
    aria-current={isActive ? "step" : undefined}
    onClick={onClick}
  />
);
